import {ISignUp} from '../../../auth/interfaces/sign-up.interface';
import {IInvitedSignUp} from '../../../auth/interfaces/invited-sign-up.interface';
import {IUser} from '../../interfaces/user.interface';
import { IResetPassword } from '../../interfaces/reset-password.interface';

export class SignUp {
  static readonly type = '[Auth] sign up new user';

  constructor(public signUpFormValue: ISignUp) {
  }
}

export class InvitedSignUp {
  static readonly type = '[Auth] sign up new user by invitation from email';

  constructor(public signUpFormValue: IInvitedSignUp) {
  }
}

export class Login {
  static readonly type = '[Auth] login user';

  constructor(public loginData: { email: string, password: string }) {
  }
}

export class CheckUser {
  static readonly type = '[Auth] check if it is actual user';

  constructor(public loginData: { pharmacyID: string, email: string, password: string }) {
  }
}

export class SetPharmacyId {
  static readonly type = '[Auth] set a pharmacy chosen by user on login flow';

  constructor(public pharmacyId: string) {
  }
}

export class UpdateUserAccount {
  static readonly type = '[Auth] update current user';

  constructor(public user: IUser) {
  }
}

export class LockSystem {
  static readonly type = '[Auth] lock the screen';

  constructor(public lock: boolean) {
  }
}

export class UserHasPin {
  static readonly type = '[Auth] check if user pin has been set';

  constructor() {
  }
}
// The ActiveUser is whoever unlocked the system using their pin.  It may be the logged-in user, but it may not be.
export class SetActiveUser {
  static readonly type = '[Auth] if true, the current user was responsible for unlocking the system';

  constructor(public pinUser: IUser) {
  }
}

export class Logout {
  static readonly type = '[Auth] logout';
}

export class HideAlibiWarning {
  static readonly type = '[Auth] hide a message about an alibi for amend transaction flow';
}

export class CloseUserAccount {
  static readonly type = '[Auth] remove current user from the system';
}

export class RequestResetByEmail {
  static readonly type = '[Auth] reset password initial step';

  constructor(public email: string) {
  }
}

export class ResetPassword {
  static readonly type = '[Auth] reset password confirmation';

  constructor(public resetData: IResetPassword) {
  }
}

export class ValidateInvitation {
  static readonly type = '[Auth] validate user invitation';

  constructor(public Email: string, public Password: string) {
  }
}
export class ValidatePasswordLink {
  static readonly type = '[Auth] validate user password reset link';

  constructor(public Email: string, public Code: string) {
  }
}

export class PersistUserToLocalStorage {
  static readonly type = '[Auth] store current user in localStorage';

  constructor() {}
}
export class LoadUserFromLocalStorage {
  static readonly type = '[Auth] retrieve current user from localStorage';

  constructor() {}
}

export class ClearStateAndCookies {
  static readonly type = '[Auth] Clear State And Cookies';

  constructor() {}
}

